
import { toast } from 'react-toastify';

export const isAndroidInterface = () => {
    console.log("window:", window);
    console.log("window.Android:", window.Android);
    console.log("window.Android.startTracking:", window.Android?.startTracking);
    return typeof window !== 'undefined' && window.Android && typeof window.Android.startTracking === 'function';
};

export const startAndroidTracking = (token, t) => {
    if (isAndroidInterface()) {
        try {
            window.Android.startTracking(token);
            console.log('Android tracking started');
        } catch (error) {
            console.error('Error starting Android tracking:', error);
        }
        toast.info(t('info.notification'), { position: "bottom-right" })
    }
};

export const stopAndroidTracking = (id) => {
    if (isAndroidInterface()) {
        try {
            window.Android.stopTracking(id);
            console.log('Android tracking stopped');
        } catch (error) {
            console.error('Error stopping Android tracking:', error);
        }
    }
};
